






























import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import { DialogMixin } from "../../system/mixins";
import PreviewedFormatSelector from "../../format/selectors/PreviewedFormatSelector.vue";

@Component({
  components: {
    selector: PreviewedFormatSelector,
  },
})
export default class PreviewedFormatSelectorDialog extends Mixins(DialogMixin) {
  @Prop()
  name: boolean;

  @Prop()
  shouldSelectSingleSourceAutomatically: boolean;

  data(): any {
    return {
      items: [] as FormatReference[],
      selectingItem: null as FormatReference,
      selectedItem: null as FormatReference,
    };
  }
  items: FormatReference[];
  selectingItem: FormatReference;
  selectedItem: FormatReference;

  get title(): string {
    return this.name + "選択";
  }

  async show(items: FormatReference[], selectedItem: FormatReference = null): Promise<FormatReference> {
    if (!items || (items.length === 0)) {
      // 選択肢がない場合はエラー.
      throw new Error("選択肢がありません");
    }
    if (this.shouldSelectSingleSourceAutomatically && (items.length === 1)) {
      // 選択肢が1つの場合は当該項目を選択する.
      return items[0];
    }
    // 選択UI表示.
    this.items = items.concat();

    // 2回目以降のダイアログ表示で、IEがPDFを表示してくれないので対策している
    this.selectingItem = null;
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.selectingItem = !selectedItem
          ? items[0]
          : selectedItem;
      });
    });

    return this.showModal(async () => {
      this.selectedItem = null;
      await this.waitHidden();
      return this.selectedItem;
    });
  }

  select(): void {
    this.selectedItem = this.selectingItem;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }

  formatSelected(format: FormatReference): void {
    this.selectedItem = format;
    this.isVisible = false;
  }
}
